import "./App.less";
import {BackTop, Row, Col, ConfigProvider, Tabs} from "antd";
import Thai from 'antd/lib/locale/th_TH';
import MainGroup from "./ShowCase/MainGroup";
import GlobalStyle from "./Styles/GlobalStyle";
import MainCareer from "./ShowCase/MainCareer";
import MainCourse from "./ShowCase/MainCourse";

const {TabPane} = Tabs;

function App() {

    return (
        <ConfigProvider locale={Thai}>
            <GlobalStyle/>
            <div className="App">

                <Tabs type="card" centered>
                    <TabPane tab="ดูข้อมูลตามกลุ่มอาชีพ" key="1" style={{margin: 'auto'}}>
                        <MainGroup/>
                    </TabPane>
                    <TabPane tab="ดูข้อมูลจากอาชีพทั้งหมด" key="2" style={{margin: 'auto'}}>
                        <MainCareer/>
                    </TabPane>
                    <TabPane tab="คอร์สเรียน" key="3" style={{margin: 'auto'}}>
                        <MainCourse/>
                    </TabPane>
                </Tabs>
                <Row justify={'end'}>
                    <Col>
                        <i>ข้อมูล ณ วันที่ : 1 ธันวาคม 2564</i>
                    </Col>
                </Row>
                <BackTop/>
            </div>
        </ConfigProvider>
    );
}

export default App;
